var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c("caption", [
            _vm._v(
              "\n             " +
                _vm._s(_vm.$gettext("Von mir geteilte Seiten")) +
                "\n         "
            ),
          ]),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Seite")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Lesen")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Lesen & Schreiben")))]),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "actions",
                },
                [_vm._v(_vm._s(_vm.$gettext("Aktionen")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.releasedElements, function (element) {
              return _c(
                "tr",
                {
                  key: element.id,
                },
                [
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getElementUrl(element),
                        },
                      },
                      [
                        _vm._v(
                          "\n                         " +
                            _vm._s(element.attributes.title) +
                            "\n                     "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    element.attributes["read-approval"].users.length > 0
                      ? _c(
                          "span",
                          {
                            attrs: {
                              role: "checkbox",
                              "aria-checked": "true",
                              "aria-disabled": "true",
                            },
                          },
                          [
                            _c("studip-icon", {
                              attrs: {
                                shape: "accept",
                                role: "info",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    element.attributes["write-approval"].users.length > 0
                      ? _c(
                          "span",
                          {
                            attrs: {
                              role: "checkbox",
                              "aria-checked": "true",
                              "aria-disabled": "true",
                            },
                          },
                          [
                            _c("studip-icon", {
                              attrs: {
                                shape: "accept",
                                role: "info",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "actions",
                    },
                    [
                      _c("studip-action-menu", {
                        attrs: {
                          items: _vm.menuItems,
                        },
                        on: {
                          editReleases: function editReleases($event) {
                            return _vm.displayEditReleases(element)
                          },
                          clearReleases: function clearReleases($event) {
                            return _vm.displayClearReleases(element)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showEditReleases
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Freigabe bearbeiten"),
              confirmText: _vm.$gettext("Speichern"),
              confirmClass: "accept",
              closeText: _vm.$gettext("Schließen"),
              closeClass: "cancel",
              height: "480",
              width: "720",
            },
            on: {
              confirm: _vm.storeReleases,
              close: _vm.closeEditReleases,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c("courseware-content-permissions", {
                        attrs: {
                          element: _vm.selectedElement,
                        },
                        on: {
                          updateReadApproval: _vm.updateReadApproval,
                          updateWriteApproval: _vm.updateWriteApproval,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2771487836
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showClearReleases
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Löschen der Freigabe"),
              question: _vm.$gettextInterpolate(
                _vm.$gettext(
                  "Möchten Sie die Freigabe für %{ pageTitle} wirklich löschen?"
                ),
                {
                  pageTitle: this.selectedElement.attributes.title,
                }
              ),
              height: "220",
            },
            on: {
              confirm: _vm.clearReleases,
              close: _vm.closeClearReleases,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }